import { useMutation, useQuery } from "@tanstack/react-query";
import {
  type VerifyEmailForm,
  type User,
  type Register,
  type UserLogin,
  type LoginResponse,
} from "utils/types/user.type";
import { client } from "./api-client";

export const useLogin = () =>
  useMutation<
    LoginResponse,
    Error,
    UserLogin
  >(
    async (data) =>
      await client("admin/login", {
        data,
      }).then((res) => res.data)
  );

export const useRefreshToken = () =>
  useMutation<LoginResponse, Error, string>(
    async (refreshToken) =>
      await client("admin/refresh-token", {
        data: { refreshToken },
      }).then((res) => res.data)
  );

export const useLogout = () =>
  useMutation<{ message: string }, Error, undefined>(
    async () =>
      await client("admin/logout", {
        method: "POST",
      }).then((res) => res.data)
  );

export const useSignUp = () =>
  useMutation<{ user: User }, Error, Register>(
    async (data) =>
      await client("auth/signupAdmin", {
        data,
      })
  );

export const useVerifyEmail = () =>
  useMutation<
    { user: User; token: { access_token: string } },
    Error,
    VerifyEmailForm
  >(
    async (data) =>
      await client(`auth/verifyEmail`, {
        data,
      })
  );

// Request password reset (authenticated admin)
export const useRequestPasswordReset = () =>
  useMutation<{ message: string }, Error, string>(
    async (email) =>
      await client(`admin/request-password-reset?email=${email}`, {
        method: "POST",
      }).then((res) => res.data)
  );




export const useGetTransactionActivity = () =>
  useQuery<any, Error>(
    ["getTransactionActivity"],
    async () => await client(`auth/getTransactionActivity`)
  );
